import { Card, CardFooter, CardHeader, CardTitle, CardContent, CardDescription, CardAction } from '../../shadcnComponents/ui/card';
import { Button } from '../../shadcnComponents/ui/button';
import { XMarkIcon } from '@heroicons/react/24/solid';

export function DeleteElement(props) {

    function deleteClicked() {
        props.deleteSelected()
    }

    function cancelDeleteClicked() {
        props.unsetNamesToDelete()
        document.getElementById('delete-file').classList.add('hidden');
    }

    return (
        <div id='delete-file' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    {props.message ?
                        <CardTitle>{props.message}</CardTitle>
                        :
                        <CardTitle>{props.namesToDelete.length + ' ' + `${props.namesToDelete.length == 1 ? 'στοιχείο έχει επιλεγεί για διαγραφή' : 'στοιχεία έχουν επιλεγεί για διαγραφή'}`}</CardTitle>
                    }
                    {props.message ?
                        <CardDescription>
                            {`Επιθυμείτε την οριστική διαγραφή ${props.namesToDelete.length == 1 ? 'της;' : 'τους;'};`}
                        </CardDescription>
                        :
                        <CardDescription>
                            {`Επιθυμείτε την οριστική διαγραφή ${props.namesToDelete.length == 1 ? 'του;' : 'τους;'};`}
                        </CardDescription>
                    }
                    <CardAction>
                        <Button onClick={() => { cancelDeleteClicked() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                {props.message ?
                    <></>
                    :
                    <CardContent className="flex flex-col h-full overflow-auto gap-1">
                        {props.namesToDelete.map(each =>
                            <div className='flex flex-row items-center justify-start' key={props.namesToDelete.indexOf(each) + '-delete'}>
                                <div className='text-start'>
                                    <span className='mr-3 text-chart-2'>•</span>{each}
                                </div>
                            </div>
                        )}

                    </CardContent>
                }
                <CardFooter className='gap-5 w-full justify-end'>
                    <Button variant={'yes'} onClick={() => { deleteClicked() }}>
                        Ναι
                    </Button>
                    <Button variant={'no'} onClick={() => { cancelDeleteClicked() }}>
                        Όχι
                    </Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default DeleteElement